"use client";

import { Button } from "@heroui/button";
import { Input } from "@heroui/input";
import { Send } from "lucide-react";

export function SubscribeForm() {
  return (
    <div className="flex w-full justify-center">
      <div className="my-8 w-full rounded-xl bg-content2 p-4">
        <header className="m-0 font-sans text-xl font-medium text-black dark:text-white">
          Subscribe
        </header>
        <p className="mb-4 mt-2 font-sans leading-normal text-foreground-600">
          Get an email whenever I publish a new thought.
        </p>
        <form
          action="https://buttondown.email/api/emails/embed-subscribe/karl"
          method="post"
          target="popupwindow"
          onSubmit={() => {
            window.open("https://buttondown.email/karl", "popupwindow");
            return true;
          }}
          className="embeddable-buttondown-form"
        >
          <fieldset
            className={`mb-4 flex flex-col items-start gap-2 font-sans`}
          >
            <div className="flex w-full items-center gap-4">
              <Input
                label="Your email"
                type="email"
                variant="faded"
                name="email"
                aria-label="Your email input"
                id="bd-email"
                placeholder="hello@email.com"
                required
                classNames={{
                  inputWrapper: "pr-2",
                }}
                endContent={
                  <Button
                    color="primary"
                    type="submit"
                    name="Subscribe"
                    aria-label="Subscribe"
                    radius="none"
                    className="size-9 rounded-md text-foreground"
                    isIconOnly
                    startContent={<Send size={16} />}
                  />
                }
              />
              <input type="hidden" value="1" name="embed" />
            </div>
          </fieldset>
          <div className="mt-4 flex items-center justify-between font-sans">
            <div>
              <span className=" text-foreground-600">
                Or you can subscribe via{" "}
              </span>
              <a
                href="https://kejk.tech/rss.xml"
                target={"_blank"}
                rel={"noopener noreferrer"}
                className="font-medium text-foreground-700 underline decoration-2 underline-offset-2 hover:text-foreground"
              >
                RSS
              </a>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
